Vue.component('faq', {
  data() {
    return {
      searchTerm: '',
      faqItems: jsonQuestions,
      searchResults: [],
      isSearchOpen: false,
      listView: false,
      arrowCounter: 0,
      loadedListView: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  methods: {
    switchFaqView(result = null) {
      this.listView = !this.listView;

      Vue.nextTick(() => {
        if (this.listView && !this.loadedListView) {
          fInitScrollSpy();
          fAccordion();
          fSticky();

          this.loadedListView = true;

          if (result != null) {
            setTimeout(() => {
              this.openQuestion(result);
            }, 0);
          }
        }

        if (result === null) {
          const scrollDest = document.querySelector('.js-scrollspy');
          scrollIt(scrollDest, 400, 'easeInQuad', 0);
        }
      });
    },
    inputChanged() {
      if (this.searchTerm.length >= 3) {
        this.filterResults();
        this.isSearchOpen = true;
      } else {
        this.isSearchOpen = false;
      }
    },
    selectCategory(e) {
      e.preventDefault();
      this.switchFaqView();

      Vue.nextTick(() => {
        const scrollDestEl = document.getElementById(e.target.dataset.faqResult);
        const scrollDest = scrollDestEl.getBoundingClientRect().top + window.scrollY;

        scrollIt(scrollDest, 400, 'easeInQuad', 0);
      });

      return false;
    },
    selectQuestion(result) {
      if (!this.listView) {
        this.switchFaqView(result);
      } else {
        this.openQuestion(result);
      }

      this.resetSearch();
    },
    openQuestion(result) {
      const questionAccordion = document.querySelector(`[data-qid="${result.id}"]`);
      const questionAccordionTrigger = questionAccordion.querySelector('.js-accordion-open');

      if (!questionAccordion.getAttribute('data-accordion-active')) {
        questionAccordionTrigger.click();
      }

      setTimeout(() => {
        scrollIt(questionAccordion.getBoundingClientRect().top, 400, 'easeInQuad', 0);
      }, 0);
    },
    onArrowDown() {
      if (this.arrowCounter < this.searchResults.length - 1) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      this.selectQuestion(this.searchResults[this.arrowCounter]);
    },
    handleClickOutside(e) {
      if (e.target.closest('.faq__search__results') === null || !e.target.classList.contains('faq__search__results')) {
        this.resetSearch();
      }
    },
    filterResults() {
      this.searchResults = [];

      var ls = this.searchTerm.toLowerCase();

      this.faqItems.forEach((item) => {
          if ((item.question && item.question.toLowerCase().indexOf(ls) > -1)
            || (item.answer && item.answer.toLowerCase().indexOf(ls) > -1))
        {
          this.searchResults.push(item);
        }
      });
    },
    resetSearch() {
      this.searchTerm = '';
      this.searchResults = [];
      this.isSearchOpen = false;
      this.arrowCounter = -1;
    },
  },
});
